import { render, staticRenderFns } from "./fact_table.vue?vue&type=template&id=daf5c2d4&scoped=true&"
import script from "./fact_table.vue?vue&type=script&lang=ts&"
export * from "./fact_table.vue?vue&type=script&lang=ts&"
import style0 from "./fact_table.vue?vue&type=style&index=0&id=daf5c2d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf5c2d4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VDivider,VFlex,VLayout,VSpacer,VTextField})
